import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, RefreshCw } from "lucide-react";
import { readingError } from "@/components/readerMessages";
import { ReadingMaterialChoice } from "@/components/ReadingMaterialChoice";
export const RereadButton = ({ jobId, canReread, inProgress, onStarted, hasPreviousResult = false }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const lock = useRef(false);
  const [materialPreview,setMaterialPreview]=useState(null),[materialBusy,setMaterialBusy]=useState(false);
  const reloadMaterial=async()=>{const {data}=await api.get(`/reader/jobs/${jobId}/reread-preview`,{timeout:120000});setMaterialPreview(data);};
  const start = async () => {
    if (lock.current || busy || inProgress || !canReread) return;
    lock.current = true; setBusy(true); setError("");
    try {
      const { data: preview } = await api.get(`/reader/jobs/${jobId}/reread-preview`, { timeout: 120000 });
      setMaterialPreview(preview);
      if (preview.material?.required) return;
      if (!preview.can_start) { setError("Non è possibile avviare una nuova lettura adesso. Aggiorna lo stato o contatta l'assistenza."); return; }
      const { data } = await api.post(`/reader/jobs/${jobId}/reread`, { confirm_cost: true, preview_hash: preview.preview_hash, maximum_cost_usd: preview.maximum_cost_usd, material_token: preview.material?.token }, { timeout: 120000 });
      onStarted?.(data);
    } catch (e) { setError(readingError(e, hasPreviousResult)); }
    finally { lock.current = false; setBusy(false); }
  };
  if (inProgress || !canReread) return null;
  return <div className="space-y-2 border-t pt-4" data-testid={`reread-${jobId}`}>
    <ReadingMaterialChoice jobId={jobId} material={materialPreview?.material} onChanged={reloadMaterial} onBusyChange={setMaterialBusy}/>
    <Button variant="outline" onClick={start} disabled={busy||materialBusy||materialPreview?.material?.required}>{busy ? <Loader2 size={15} className="mr-2 animate-spin" /> : <RefreshCw size={15} className="mr-2" />}{busy ? "Avvio nuova lettura…" : "Rileggi il disegno"}</Button>
    <p className="text-xs text-muted-foreground">{hasPreviousResult ? "Avvia una nuova lettura del PDF originale. Potrai confrontarla con quella già in uso prima di sostituirla." : "Riprova a leggere il PDF originale. I dati saranno disponibili solo quando la lettura sarà completata."}</p>
    {error && <p role="alert" className="text-sm text-red-800">{error}</p>}
  </div>;
};

